import { InvitationTypes } from '../enums/invitationTypes.enum';

export const isInvitationTypeValid = (type: string) => Object.values(InvitationTypes).includes(type as InvitationTypes);
